import { Field } from "./Field";

export class DecimalField extends Field {
  min:number;
  max:number;
  step:number;
  type:string ='decimal'
  constructor(name: string, value: any,min:number,max:number,step:number, onChange: (newValue: any) => void) {
    super(name, value, onChange);
    this.min = min;
    this.max = max;
    this.step = step;
  }
  public render(): HTMLElement {
    const container = this.createContainer();
    const input = document.createElement('input');
    input.type = 'number';
    input.id = this.name;
    input.name = this.name;
    input.value = this.value;
    input.step = this.step + '';
    this.min = this.min;
    this.max = this.max;
    input.addEventListener('input', (event) => {
      this.value = parseFloat((event.target as HTMLInputElement).value);
      const target = event.target as HTMLInputElement;
      this.onChange(parseFloat(target.value));
    });
    container.appendChild(input);

    return container;
  }
}
